module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mob_akcios_area a_new_bordrtwo"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 no-widget-padding"
  }, [_c('div', {
    staticClass: "mob_akcios_conts"
  }, [_c('div', {
    staticClass: "mob_akcios_conts_box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mob_akcios_conts_box_carousel"
  }, [_c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "recommended-item-carousel-two",
      "data-ride": "carousel"
    }
  }, [_c('div', {
    staticClass: "carousel-inner"
  }, _vm._l((_vm.products), function(list, i) {
    return _c('div', {
      staticClass: "item",
      class: {
        active: i == 0
      }
    }, [_c('div', {}, [_c('div', {
      staticClass: "product-img-wrapper"
    }, [_c('div', {
      staticClass: "single-products"
    }, [_c('div', {
      staticClass: "row"
    }, _vm._l((list), function(p) {
      return _c('div', {
        staticClass: "col-sm-3 col-xs-6"
      }, [_c('product-list-view', {
        key: p.id,
        staticStyle: {
          "width": "auto"
        },
        attrs: {
          "product": p
        }
      })], 1)
    }))])])])])
  })), _vm._v(" "), _vm._m(1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "akcios_menu_cont"
  }, [_c('div', {
    staticClass: "akcios_menu_cont_box text-center"
  }, [_c('ul', [_c('li', [_vm._v("AKCIÓS TERMÉKEK")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "right recommended-item-control",
    attrs: {
      "href": "#recommended-item-carousel-two",
      "data-slide": "next"
    }
  }, [_c('span', [_vm._v("Több")]), _c('i', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a71cc5c2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/pages/page/widgets/DiscountProductsWidget.vue
// module id = 124
// module chunks = 0 1 2